import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: colors.indigo[900],
    main: '#142bad',
    light: colors.indigo[100]
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: '#36449d',
    light: colors.blue['A400']
  },
  success: {
    contrastText: black,
    dark: colors.green[900],
    main: '#87e887',
    light: colors.green[400]
  },
  info: {
    contrastText: black,
    dark: colors.blue[900],
    main: '#ffcd3d',
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: black,
    dark: colors.red[900],
    main: '#ff5f5d',
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  background: {
    default: '#e5e9ff',
    paper: white
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200]
};
